import { render, staticRenderFns } from "./ClientIntercomsTab.vue?vue&type=template&id=1c333dd4&"
import script from "./ClientIntercomsTab.vue?vue&type=script&lang=js&"
export * from "./ClientIntercomsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports